import { Heart, Target, Eye } from "lucide-react";

const AboutSection = () => {
  return (
    <section id="about" className="py-16 lg:py-24 px-4 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-72 h-72 bg-emerald-50/60 rounded-full -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-teal-50/60 rounded-full translate-y-1/2 -translate-x-1/4" />

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-4 lg:mb-6">
            Sobre o Vita Sana
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Um espaço pensado para acolher quem cuida
          </p>
          <div className="w-16 lg:w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-b from-emerald-50/80 to-white border border-emerald-100/50 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300">
              <Eye className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Nossa Visão</h3>
            <p className="text-gray-600 leading-relaxed">
              Ser referência em espaço de coworking para profissionais da saúde em Santa Maria, proporcionando um ambiente que una bem-estar, tecnologia e acolhimento.
            </p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-b from-teal-50/80 to-white border border-teal-100/50 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300">
              <Target className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Nossa Missão</h3>
            <p className="text-gray-600 leading-relaxed">
              Oferecer infraestrutura completa e acolhedora para que psicólogos, terapeutas e profissionais da saúde possam se concentrar no que realmente importa: cuidar de pessoas.
            </p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-b from-blue-50/80 to-white border border-blue-100/50 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-300">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Nossos Valores</h3>
            <p className="text-gray-600 leading-relaxed">
              Acolhimento, ética, conforto e profissionalismo. Cada detalhe do Vita Sana foi projetado para oferecer a melhor experiência para você e seus pacientes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
